import { complete as tokenComplete } from './token';

export default (userManager) => {
  userManager.getUser().then((user) => {
    window.sessionStorage.setItem('currentRedirectURI', window.location.href);
    
    if (!user)  {
      userManager.signinRedirect();
      return;
    }

    tokenComplete(user);
  });
};
